/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Native_ModulesInputs */

const en_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native modules`)
};

const ar_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وحدات أصلية`)
};

const bn_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নেটিভ মডিউল`)
};

const de_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Module`)
};

const es_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módulos nativos`)
};

const fr_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modules natifs`)
};

const pt_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módulos nativos`)
};

const zh_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本机模块`)
};

const tr_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yerel modüller`)
};

const ru_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственные модули`)
};

const pl_svchip_native_modules = /** @type {(inputs: Svchip_Native_ModulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moduły natywne`)
};

/**
* | output |
* | --- |
* | "Native modules" |
*
* @param {Svchip_Native_ModulesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_native_modules = /** @type {((inputs?: Svchip_Native_ModulesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Native_ModulesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_native_modules(inputs)
	if (locale === "bn") return bn_svchip_native_modules(inputs)
	if (locale === "de") return de_svchip_native_modules(inputs)
	if (locale === "es") return es_svchip_native_modules(inputs)
	if (locale === "fr") return fr_svchip_native_modules(inputs)
	if (locale === "pt") return pt_svchip_native_modules(inputs)
	if (locale === "zh") return zh_svchip_native_modules(inputs)
	if (locale === "tr") return tr_svchip_native_modules(inputs)
	if (locale === "ru") return ru_svchip_native_modules(inputs)
	if (locale === "pl") return pl_svchip_native_modules(inputs)
	return en_svchip_native_modules(inputs)
});